import {
  FETCH_PARTICIPANT,
  FETCH_PARTICIPANT_FAIL,
  FETCH_PARTICIPANT_SUCCESS,
  UPDATE_PARTICIPANT,
  UPDATE_PARTICIPANT_FAIL,
  UPDATE_PARTICIPANT_SUCCESS,
} from 'redux/Reducers/Participants/ParticipantsReducer';
import Store from 'redux/store';
import { cloudloyalty } from '../clients';

export const FetchParticipant = async (User, finallyCallback = () => {}) => {
  Store.dispatch({ type: FETCH_PARTICIPANT });
  cloudloyalty(User).get('/v1/participants/me').then((response) => {
    Store.dispatch({
      type: FETCH_PARTICIPANT_SUCCESS,
      payload: {
        ...response,
      },
    });
  }).catch((e) => {
    Store.dispatch({
      type: FETCH_PARTICIPANT_FAIL, error: e,
    });
  })
    .finally(() => {
      finallyCallback();
    });
};

export const PutParticipant = async (User, finallyCallback = () => {}, payload = {}) => {
  Store.dispatch({ type: UPDATE_PARTICIPANT });
  cloudloyalty(User).put('/v1/participants/me/profile', payload).then((response) => {
    Store.dispatch({
      type: UPDATE_PARTICIPANT_SUCCESS,
      payload: {
        ...response,
      },
    });
  }).catch((e) => {
    Store.dispatch({
      type: UPDATE_PARTICIPANT_FAIL, error: e,
    });
  })
    .finally(() => {
      finallyCallback();
    });
};
